import React, { useState, useEffect } from 'react';
import { Auth, API, graphqlOperation } from 'aws-amplify';
import { listWebPrivateProjects } from '../graphql/queries';
import { createProject, updateProject } from '../graphql/mutations';
import AlertDialog from './Dialog';
import { SimpleSnackbar } from './SnackBar';

const SaveButton = (props) => {

    const [owner, setOwner] = useState('');
    const [privateTitle, setPrivateTitle] = useState('');
    const [openingTitle, setOpeningTitle] = useState(props.openingTitle);
    const [projectCode, setProjectCode] = useState('');
    const [allExistingProjects, setAllExistingProjects] = useState([]);
    const [alertStatus, setAlertStatus] = useState(false);
    const [message, setMessage] = useState('');
    const [save, setSave] = useState(false);
    const [saveAlert, setSaveAlert] = useState(false);
    const [overWrite, setOverWrite] = useState(false);

    useEffect(()=>{

        getAuthUserID();

    }, [])

    useEffect(()=>{

        if (save) {

            handleSave();

        }
    })

    const getAuthUserID = () => {

        Auth.currentAuthenticatedUser()
            .then(user => {
                setOwner(user.attributes.sub);
            }
            )
            .catch(error =>
                console.log(error)

            )

    }

    const handleSave = () => {
        
        if (projectExists(props.projectTitle)){

            if (privateTitle === openingTitle){

                updateWebProject();
                setSaveAlert(true);
                setSave(false);

            } else {

                setOverWrite(true);
                setSave(false);

            }

        } else {

            if (owner === '') {
                setMessage("Please log in or create an account to save projects!");
                setAlertStatus(true);
                setSave(false);
    
            } else if (props.projectTitle === '') {
                setMessage("Please name your project before saving!");
                setAlertStatus(true);
                setSave(false);

            } else if (props.projectTitle.length > 20){
                setMessage("Please come up with a name that is up to 20 characters long ✂️");
                setAlertStatus(true);
                setSave(false);

            } else {
                let type = allExistingProjects.length.toString();
                createNewProject(type);
                setOpeningTitle(props.projectTitle);
                setSave(false);
            }
        }

    }

    const projectExists = (title) => {
        if (allExistingProjects.filter(project => project.privateTitle === title).length > 0) {
            return true;
        } else {
            return false;
        }
    }

    const updateWebProject = async () => {

        let currentProject = allExistingProjects.filter(project => project.privateTitle === privateTitle);
        
        try {
    
            let updated_project_data = {
                id: currentProject[0].id,
                type: currentProject[0].type, 
                projectCode: projectCode,
                updatedFromWebApp: true,

            }
            
            await API.graphql(graphqlOperation(updateProject, {input: updated_project_data}))
            console.log('project was saved')
            setSaveAlert(true);
            setSave(false);

        }

        catch(error){

            console.log(error)
            setMessage("Something went wrong, please try again later.");
            setAlertStatus(true);
        }
    
    }

    const createNewProject = async (type) => {

        try {

            let project_data = {
                projectCode: projectCode,
                privateTitle: privateTitle,
                type: type,
                createdFromWebApp: true,
            }

            await API.graphql(graphqlOperation(createProject, { input: project_data }))
            setSaveAlert(true);
            setSave(false);
                
        }

        catch (error) {
            console.log(error)
            setMessage("Something went wrong, please try again later.");
            setAlertStatus(true);

        }

    }

    const getAllProjects = async () => {

        let filter = { type: { contains: "PRIVATE_PROJECT" } };
        let id = owner;
        const projects = await API.graphql(graphqlOperation(listWebPrivateProjects, { creator: id, filter: filter, limit: 400 }));
        setAllExistingProjects(projects.data.listWebPrivateProjects.items.reverse())

    }

    const renderAlert = (msg) => {

        return (
            <SimpleSnackbar message={msg} close={setAlertStatus} status={true} severity={'warning'} duration={6000}></SimpleSnackbar>
        )

    }

    const renderSaveAlert = (msg) => {

        return (
            <SimpleSnackbar message={msg} close={setSaveAlert} status={true} severity={'success'} duration={6000}></SimpleSnackbar>
        )

    }

    const handleOverWriteAgree = () => {

        updateWebProject();
        setOpeningTitle(privateTitle);

    }

    const handleOverWriteClose = () => {

        setOverWrite(false);

    }

    const renderOverWriteAlert = () => {

        return (<AlertDialog agree={handleOverWriteAgree} close={handleOverWriteClose} canceltxt={'Cancel'} proceedtxt={'Overwrite'}>
            You have already saved a project with this name. Would you like to overwrite it?
            </AlertDialog>)

    }

    return (
        <>
            <button onClick={ async ()=> {
                setPrivateTitle(props.projectTitle);
                setProjectCode(props.projectCode);
                await getAllProjects();
                setSave(true);
                
            }
                } 
                style={{ height: '50px', width: "90%", marginTop: '10px', marginBottom: '10px' }}>
                {props.children}
            </button>
            {overWrite && renderOverWriteAlert()}
            {alertStatus && renderAlert(message)}
            {saveAlert && renderSaveAlert('Your project was saved succesfully!')}
        </>

    )

}

export default SaveButton;